var version = "10.89.0";

export { version as v };
//# sourceMappingURL=package-19f9cb2b.js.map
